import { type Accessor, createMemo } from 'solid-js';

/**
 * Custom hook for generating contextId from region data
 */
export function useContextId(
  projectId: string,
  region: string | undefined
): Accessor<string | undefined> {
  const contextIdSignal = createMemo(() => {
    if (!region) {
      return undefined;
    }
    return `trn:2:tc:${region}:projects:${projectId}`;
  });

  return contextIdSignal;
}
